/** A settings table: each row is a label with a short description on the left, its control on the right. */
import type { ReactNode } from 'react';

export function OptionTable({ className, children }: { className?: string; children: ReactNode }) {
  return (
    <table className={className ? `option-table ${className}` : 'option-table'}>
      <tbody>{children}</tbody>
    </table>
  );
}

export function OptionRow({
  label,
  hint,
  htmlFor,
  className,
  children,
}: {
  label: string;
  hint?: string;
  /** The control's id, so tapping the label works the control (checkboxes, selects). */
  htmlFor?: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <tr className={className}>
      <th scope="row">
        <label htmlFor={htmlFor}>{label}</label>
        {hint && <span className="hint">{hint}</span>}
      </th>
      <td>{children}</td>
    </tr>
  );
}
